<!--center pane "header"-->
<app-alert *ngIf="(outstandingKickbacks$ | async)" [message]="'All outstanding kickback requests for this business must be completed in order to submit to Funding Desk'" [level]="'warning'"></app-alert>
<div #detailsViewContainer *ngIf="(activeActionItem$ | async) as actionItem;" class="details-view-container">

  <!--Title-->
  <div class="detailsHeader tw-px-6 tw-py-4 tw-border-b detailsBorder">
    <div class="tw-flex tw-justify-between">
      <div>
        <h2 class="!tw-mb-0 tw-font-semibold">
          <strong>
            {{actionItem.type}}
            <span
              *ngIf="actionItem.typeId === 1 && actionItem.details?.additionalDetails?.issueType as issueType">: {{issueType.issueTypeLabel}}
              </span>
          </strong>
        </h2>
        <p class="tw-pt-1">for
          <a interactive target="_blank" [routerLink]="['/borrower/' + actionItem.borrowerId]">{{ actionItem.name }}</a>
          <span class="tw-font-semibold"> {{actionItem.borrowerStatus | startcase }}</span>
        </p>
      </div>
      <div class="tw-pt-2 tw-ml-auto">
        <ng-container *ngIf="showCompletionCheckbox">
          <mat-checkbox *ngIf="isManuallyCompletableActionItemType" class="tw-font-semibold tw-text-right tw-w-full requestCompleteCheckBox"
                        (change)="complete()"
                        [checked]="!!actionItem.completed"
                        [disabled]="actionItem.completed"
                        labelPosition="before"
          >
            {{ isRequestActionItemType ? 'Request' : '' }} Complete
          </mat-checkbox>
        </ng-container>
        <p class="tw-ml-auto detailsCommentsDate">{{actionItem.created | date:'MMM dd, yyyy, hh:mm a'}}</p>
      </div>
    </div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <div>
        <div>
          <span class="text-muted">Assigned to</span>
          <span class="tw-ml-2 tw-font-bold">{{(actionItemsUser$ | async).fullName}}</span>
        </div>
        <div
          class="tw-pt-1 text-muted"
          *ngIf="actionItem.details?.additionalDetails?.initiatorName as initiatorName">
          <span>Requested by {{initiatorName}}</span>
        </div>
      </div>
      <app-borrower-contact-methods
        *ngIf="!actionItem.completed"
        [hideEmailButton]="!isRequestActionItemType"
        [hideSmsButton]="!isRequestActionItemType"
        [borrowerId]="actionItem.borrowerId">
      </app-borrower-contact-methods>

    </div>
  </div>
  <!--Description-->
  <div class="tw-px-6 tw-py-4 tw-border-b detailsBorder detailsHeader">
    <div class="tw-flex tw-justify-between tw-mb-2">
      <span class="tw-font-bold">DESCRIPTION</span>
    </div>
    <contract-request-details
      *ngIf="actionItem.details?.contract_request && actionItem.details?.deal"
      [contract_request]="actionItem.details.contract_request"
      [deal]="actionItem.details?.deal"
      [canEditContractRequests]="false">
    </contract-request-details>
    <p>{{ formattedDescription }}</p>
  </div>
  <!--Comments-->
  <div #commentsList class="comments-list-container">
    <div *ngFor="let comment of actionItem.details?.additionalDetails?.comments" class="tw-px-6 tw-py-4 tw-border-b detailsBorder">
      <span class="tw-font-semibold">{{comment.authorName}}</span>
      <span *ngIf="comment.isForLender" class="tw-italic"> - Lender</span>
      <span class="tw-pl-2.5 detailsCommentsDate">
          {{comment.created | date:'MM/dd/YYYY'}} - {{comment.modified | timeago }}
        </span>
      <div class="tw-pt-2" [innerHTML]="comment.description"></div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div *ngIf="isRequestActionItemType && !actionItem.completed" #newCommentContainer class="tw-px-6 tw-py-4 new-comment-container">
    <div *ngIf="!(commentSaving$ | async)" class="new-comment-container">
      <formly-form [model]="newCommentModel" [fields]="fields" [options]="options" [form]="form" [disabled]="(commentSaving$ | async)"></formly-form>
      <div class="tw-grid tw-grid-flow-col tw-items-end">
        <button
          mat-stroked-button
          class="tw-h-12"
          [color]="'primary'"
          type="button"
          *ngIf="newCommentModel.description"
          (click)="addComment()">
          <span *ngIf="!(commentSaving$ | async) else buttonSavingState">Save</span>
          <ng-template #buttonSavingState>
            <mat-spinner diameter="24"></mat-spinner>
          </ng-template>
        </button>
      </div>
    </div>
    <div *ngIf="commentSaving$ | async" class="tw-justify-center tw-items-center tw-flex tw-min-h-full">
      <div>
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    </div>

  </div>

</div>

<div *ngIf="loading$ | async" class="tw-justify-center tw-items-center tw-flex tw-min-h-full">
  <div>
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</div>
